import React, { useState } from "react";
import { HiMenu, HiOutlineXCircle, HiViewGrid, HiCollection, HiInformationCircle, HiOutlineTag, HiOutlineMail } from "react-icons/hi";
import { HiTruck, HiNewspaper, HiMapPin } from "react-icons/hi2";
import { Link } from "react-router-dom";
import { TbLicense } from "react-icons/tb";
import { GrGallery } from "react-icons/gr";
import { ImFileText2 } from "react-icons/im";
import { LiaPagerSolid } from "react-icons/lia";
import LoadingIndicator from "../General/LoadingIndicator";

const SharedLayout = ({ children }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <div className="flex h-screen overflow-hidden bg-gray-800">
            {/* Sidebar */}
            <div
                className={`bg-gray-800 text-white transition-all duration-300 flex flex-col ${isSidebarOpen ? "w-64" : "w-16"
                    } h-screen`}
            >
                <div className="flex items-center justify-between p-4">
                    <span className="text-lg font-bold">
                        {isSidebarOpen ? "منو" : ""}
                    </span>
                    <button onClick={toggleSidebar}>
                        {isSidebarOpen ? (
                            <HiOutlineXCircle size={24} />
                        ) : (
                            <HiMenu className="me-5" size={24} />
                        )}
                    </button>
                </div>
                <nav className="mt-10 flex-grow overflow-y-auto">
                    <Link
                        to="/dashboard"
                        className="flex items-center p-4 hover:bg-gray-700"
                    >
                        <HiViewGrid size={24} color="white" />
                        {isSidebarOpen && <span className="mr-4 text-white">داشبورد</span>}
                    </Link>
                    <Link
                        to="/product"
                        className="flex items-center p-4 hover:bg-gray-700"
                    >
                        <HiCollection size={24} color="white" />
                        {isSidebarOpen && <span className="mr-4 text-white">محصولات</span>}
                    </Link>
                    <Link
                        to="/project"
                        className="flex items-center p-4 hover:bg-gray-700"
                    >
                        <HiTruck size={24} color="white" />
                        {isSidebarOpen && <span className="mr-4 text-white">پروژه ها</span>}
                    </Link>
                    <Link
                        to="/contactInfo"
                        className="flex items-center p-4 hover:bg-gray-700"
                    >
                        <HiInformationCircle size={24} color="white" />
                        {isSidebarOpen && <span className="mr-4 text-white">ارتباطات</span>}
                    </Link>
                    <Link
                        to="/license"
                        className="flex items-center p-4 hover:bg-gray-700"
                    >
                        <TbLicense size={24} color="white" />
                        {isSidebarOpen && <span className="mr-4 text-white">استاندار و گواهی نامه ها</span>}
                    </Link>
                    <Link
                        to="/Gallery"
                        className="flex items-center p-4 hover:bg-gray-700"
                    >
                        <GrGallery size={24} color="white" />
                        {isSidebarOpen && <span className="mr-4 text-white">گالری تصاویر</span>}
                    </Link>
                    <Link
                        to="/Text"
                        className="flex items-center p-4 hover:bg-gray-700"
                    >
                        <ImFileText2 size={24} color="white" />
                        {isSidebarOpen && <span className="mr-4 text-white">متون ثابت وب‌سایت</span>}
                    </Link>
                    <Link
                        to="/MainPage"
                        className="flex items-center p-4 hover:bg-gray-700"
                    >
                        <LiaPagerSolid size={30} color="white" />
                        {isSidebarOpen && <span className="mr-4 text-white">لندینگ پیج</span>}
                    </Link>
                    <Link
                        to="/ArticleCategory"
                        className="flex items-center p-4 hover:bg-gray-700"
                    >
                        <HiOutlineTag size={24} color="white" />
                        {isSidebarOpen && <span className="mr-4 text-white">دسته‌بندی مقالات</span>}
                    </Link>
                    <Link
                        to="/Article"
                        className="flex items-center p-4 hover:bg-gray-700"
                    >
                        <HiNewspaper size={24} color="white" />
                        {isSidebarOpen && <span className="mr-4 text-white">مقالات</span>}
                    </Link>
                    <Link
                        to="/MapLocations"
                        className="flex items-center p-4 hover:bg-gray-700"
                    >
                        <HiMapPin size={24} color="white" />
                        {isSidebarOpen && <span className="mr-4 text-white">موقعیت‌های نقشه</span>}
                    </Link>
                    <Link
                        to="/ContactMessages"
                        className="flex items-center p-4 hover:bg-gray-700"
                    >
                        <HiOutlineMail size={24} color="white" />
                        {isSidebarOpen && <span className="mr-4 text-white">پیام‌های تماس</span>}
                    </Link>
                </nav>
            </div>

            {/* Main Content */}
            <div className="flex-grow bg-gray-100 p-1 h-screen overflow-y-auto overflow-x-auto">
                <LoadingIndicator />
                {children}
            </div>
        </div>
    );
};

export default SharedLayout;

